import React from 'react'
import Button from '../../../../components/button/Button'
import Checkbox from '../../../../components/checkbox/basecheckbox/Checkbox'
import { useState } from 'react'
import styles from './EnableApiAccess.styles'
import { useDispatch, useSelector } from 'react-redux'
import { componentKey } from '../../ApiSlice'
import Label from '../../../../components/label/Label'
import { LABEL_WEIGHT } from '../../../../components/label/constants'
import { enableApi } from '../../ApiSaga'
import Loadable from '../../../../components/loadable/Loadable'
import PageBody from '../../../../components/pagebody/PageBody'
import { ENVIRONMENTS, PAGE_STATE, PAGE_STATE_MESSAGE_MAP, TERMS_AND_CONDITIONS_LINK } from '../../../constants/constants'
import Config from '../../../../config.web'
import { APP_PRODUCTION_URL } from '../../../dashboard/constants'
import { Link } from 'react-router-dom'

export default function EnableApiAccess() {
	const [checked, setChecked] = useState(false)
	const { userType, loadingState } = useSelector((state) => state[componentKey])
	const dispatch = useDispatch();

	const handleApiEnabled = () => {
		dispatch(enableApi());
	}

	return (
		<Loadable currentState={loadingState.state} loadingStates={PAGE_STATE.LOADING} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
				<div style={styles.container}>
					<div style={styles.checkBoxRow}>
						<Checkbox checked={checked} onChangeCb={() => setChecked(prev => !prev)} />
						<span>By clicking, you are confirming that you have read, understood and agreed to the <a target="_blank" href={TERMS_AND_CONDITIONS_LINK}>terms and conditions</a>.</span>
					</div>
					<div style={styles.flex}>
						{
							Config.ENV === ENVIRONMENTS.STAGE ? <p style={styles.red} weight={LABEL_WEIGHT[700]}>API can be enabled only from the production site: <Link to={APP_PRODUCTION_URL} target="_blank">{new URL(APP_PRODUCTION_URL).host}</Link></p> : null
						}
						
						<Button disabled={!checked || Config.ENV === ENVIRONMENTS.STAGE } onClickCb={handleApiEnabled}>Enable API</Button>
						{
							userType !== 3 && <Label customStyles={styles.red} weight={LABEL_WEIGHT[700]}>Please Note: Upgrade to Enterprise is required for API use</Label>
						}
					</div>
				</div>
		</Loadable>
	)
}